import React from 'react';
import './NotFound.css';
import { Helmet } from 'react-helmet';
import { Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { localizedStrings } from '../../util/LocalizedStrings';

export default class NotFound extends React.Component {
    render() {
        return (
            <div className='NotFound'>
                <Helmet>
                    <meta name='prerender-status-code' content='404' />
                    <meta name='robots' content='noindex, nofollow' />
                </Helmet>
                <h1>{localizedStrings.notFoundPageTitle}</h1>
                <Link component={RouterLink} to='/' color='secondary'>
                    {localizedStrings.notFoundPageGoHome}
                </Link>
            </div>
        );
    }
}